import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#00615A',
      light: '#3BCA6E',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#8CC63F',
      contrastText: '#1A1A1A',
    },
    error: {
      main: '#f44336',
      contrastText: '#FFFFFF',
    },
    text: {
      primary: '#1A1A1A',
      secondary: '#00615A',
      placeholder: '#a5acb8',
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFFBDE',
      input: '#f7fafd',
    },
  },
  shape: { borderRadius: 8 },
  spacing: 8,

  custom: {
    input: {
      borderColor: '#b0bdd7',
      heights: {
        sm: '1.74rem',
        md: '3.2rem',
        lg: '4.5rem',
      },
      fontSizes: {
        sm: '0.7rem',
        md: '0.9rem',
        lg: '1.1rem',
      },
    },
    dropdown: {
      border: '#5f8bfe',
      shadow: 'rgba(95, 139, 254, 0.25)',
      topOffset: (size) =>
        ({
          sm: `calc(${theme.spacing(1)} + 0px)`,
          md: `calc(${theme.spacing(2)} + 0px)`,
          lg: `calc(${theme.spacing(3)} + 0px)`,
        }[size]),
    },
  },
});

export default theme;
